/**
 * @generated SignedSource<<a7251768930537b78d8d8a99421bc28d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceVersionPublishButtonFragment$data = {
  readonly id: string;
  readonly publishedAt: DateTime | null | undefined;
  readonly version: Semver;
  readonly viewerCanPublish: boolean;
  readonly " $fragmentType": "WorkspaceVersionPublishButtonFragment";
};
export type WorkspaceVersionPublishButtonFragment$key = {
  readonly " $data"?: WorkspaceVersionPublishButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionPublishButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceVersionPublishButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": "viewerCanPublish",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "PUBLISH_WORKSPACE_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"PUBLISH_WORKSPACE_VERSION\")"
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};

(node as any).hash = "cb9fa800a6870a4cd9548dc2c67575e4";

export default node;
